"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable implicit-arrow-linebreak */
var learnerModuleModel = function learnerModuleModel(objectIdType) {
  return {
    _moduleId: {
      type: objectIdType,
      ref: 'Module'
    },
    started: {
      type: Date,
      required: true
    },
    completed: Date,
    hideExercises: {
      type: Boolean
    }
  };
};
var timeStampModel = {
  timestamp: Date,
  lastActive: Date,
  // Defines if timestamp was the start or restart of intervals
  // e.g., user began pinging, or went inactive and came back
  isStart: Boolean,
  eventType: String
};
var learnerSlideModel = function learnerSlideModel(objectIdType) {
  return {
    _slideId: {
      type: objectIdType,
      ref: 'Slide'
    },
    tries: {
      type: Number,
      "default": 0
    },
    started: {
      type: Date,
      required: true
    },
    correct: {
      type: Boolean
    },
    selected: [],
    elapsedTime: [timeStampModel],
    // Used to note when a slide has been completely answered/viewed, but
    // user hasn't hit next yet
    completed: Date,
    // Used to note when a user has moved to the next slide after completing
    movedNext: Date
  };
};

/**
 * Schema for a Learner
 * @param {ObjectId} objectIdType ObjectId type from mongoose package
 * @returns Array with Collection name and defined Schema
 */
var Learner = function Learner(objectIdType) {
  if (!objectIdType) {
    throw new Error('objectIdType must be provided');
  }
  return ['Learner', {
    StudentID: {
      type: String
    },
    SeenVideos: [{
      _videoId: {
        type: objectIdType,
        ref: 'Resource'
      },
      counter: {
        type: Number,
        "default": 0
      }
    }],
    createdAt: {
      type: Date,
      required: true
    },
    updatedAt: {
      type: Date
    },
    Modules: [learnerModuleModel(objectIdType)],
    Slides: [learnerSlideModel(objectIdType)],
    ArchivedModules: [learnerModuleModel(objectIdType)],
    ArchivedSlides: [learnerSlideModel(objectIdType)],
    // New for LMS, this was StudentID in the past
    userId: {
      type: String,
      required: true
    }
  }];
};
var _default = Learner;
exports["default"] = _default;